import React, { Fragment, useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Firebase
import { db, functions } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';
import { httpsCallable } from "firebase/functions";

// Actions
import { setAlert } from '../actions/alertActions';
import { getComments_Review, getReviewById, clearEditorText, clearEditorFiles, clearUrls } from '../actions/postActions';
import { editUsername } from '../actions/authActions';
import { setPage, add_To_Recent_History, toggleCommentModal, toggleAuthModal } from '../actions/navActions';

// Layout Wrapper
import Layout from '../components/layout/Layout';

import ModalPost from '../components/Post/ModalPost';

// components
import { Button } from '@material-ui/core';
import Spinner from '../components/common/Spinner';
import TweetBox from '../components/TweetBox/TweetBox';
import Detail from '../components/Reviews/Detail';
import Review from '../components/Reviews/Review';

// Icons - material UI
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AddPhotoAlternateOutlinedIcon from '@material-ui/icons/AddPhotoAlternateOutlined';

// Modal
import CommentModal from '../components/modal/CommentModal';
import ModalContainer from '../components/modal/ModalContainer';
import Modal from '../components/modal/Modal';

const ReviewPage = ({ 
    setPage, 
    add_To_Recent_History,
    clearEditorText, 
    clearEditorFiles, 
    clearUrls,
    toggleCommentModal,
    toggleAuthModal,
    getReviewById, 
    getComments_Review,
    post: { 
        post, 
        comments,
        loadingComments,
        loading 
    }, 
    nav: {
        commentModal,
        postModal
    },
    ad,
    editUsername, 
    auth, 
    match, 
    history,
    setAlert
}) => {
    
    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);
    const [gotExecuteScroll, setGotExecuteScroll] = useState(false);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;

    // Determine if the device is mobile or tablet based on the `windowWidth` state
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    useEffect(() => {

        // Set the page
        setPage('review');
        add_To_Recent_History(url.pathname);  // current url

        // Fetch the post data based on the `match.params.id` parameter
        getReviewById(match.params.id);

    }, [ match.params.id ]);

    useEffect(() => {

        // Fetch the comments for the post if the loading state is `false` and the post data is available
        if(!loading && post) {
            // Get comments
            getComments_Review(post._id);
        }

    }, [ loading, post ]);

    useEffect(() => {

        // Add a resize event listener to update the `windowWidth` state
        window.addEventListener('resize', () => handleWindowSizeChange());
        
        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    });

    // Update the `windowWidth` state whenever the window is resized
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Handle create Comment Modal Toggle
    const handleToggle_CommentModal = () => {
        if(auth.user) {
            toggleCommentModal();
        } else {
            toggleAuthModal('comment');
        }
        

    }

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY && gotExecuteScroll){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
                
            }
        }
        // --- END Handle top nav bar display

        // For purposes of correctly displaying top nav when auto scrolling to bottom of comment detail page
        var scrollTimeout;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
            console.log('----- Scroll ended');
            setGotExecuteScroll(true);
        }, 1000);

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)
    }

    let commentList;

    if(loading || post === null) {
        commentList = <></>
    } else {
        if(comments === null || loadingComments) {
            commentList = <Spinner />;
        }
        else {
            if(comments.length > 0) {
                commentList = (
                    <div className='post_container'>
                        {comments.map((comment) => <Review key={comment._id} postDoc={comment} isComment />)}
                    </div>
                )  
            }
            else {
                commentList = (

                    <div className="no-rides">
                        <h1>No Comments</h1>
                    </div>
                );
            }
        }
    }


    let postContent;

    if(loading) {
        postContent = <Spinner />;
    }
    else {
        if(post === null) {
            postContent = (
                <div className="no-post">
                    <p>Hmm...this page doesn’t exist. Try searching for something else.</p>
                    <Button  
                        onClick={() => window.location ='/search'}
                        className="noChats__btn"
                    >
                        Search
                    </Button>
                </div>
            );
        } else {
            postContent =  (
                <Fragment>
                    <Detail 
                        post={post}
                        toggleCommentModal={toggleCommentModal}
                        history={history}
                        isTablet={isMobile}
                        commentList={commentList}
                        setScrollDirection={setScrollDirection}
                        setOldScrollY={setOldScrollY}
                        oldScrollY={oldScrollY}
                    />

                    {(!commentModal && !postModal && post?.to_user?._id === auth.user_id) && (
                        <TweetBox isTablet={isTablet} postId={post._id} comment mobile_redirect={isMobile} />
                    )} 

                    {commentList}

                    {/* <div className="no-rides" /> */}
                </Fragment>
            );
        }
    }

    const handleMixpanel = () => {

        // Initialize Mixpanel with the provided Mixpanel ID
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

        // Identify the current user by their ID
        mixpanel.identify(auth.user._id);

        // Track the Page View event
        mixpanel.track("Review Detail Page View");
    }

    // Check if the code is running in production and Mixpanel event hasn't been sent yet
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && auth.user !== null  && !hostname.includes('xbuysell')) {
        
        // Initialize Mixpanel and track the event
        handleMixpanel();

        // Set the flag to indicate that Mixpanel event has been sent
        setSentMixpanel(true);
    }

    if(localStorage.getItem("trigger_alert")) {
        const alert_type = localStorage.getItem("trigger_alert");

        if(alert_type === "comment_success"){
            setAlert('Your reply was sent', 'okay');
        }

        localStorage.removeItem("trigger_alert");
    }

    return (
        <Fragment>
            <Layout handleScroll={handleScroll} page="review">

                {!auth.loading && !auth.isAuthenticated && (
                    <div style={{margin: '12px 16px'}} className="btnRow">
                        <Button 
                            onClick={toggleAuthModal}
                            variant="outlined" 
                            className="sidebar__tweet ghost minWidth noMargin"
                        >
                            Log In
                        </Button>
                        <Button 
                            onClick={toggleAuthModal}
                            variant="outlined" 
                            className="sidebar__tweet minWidth noMargin"
                        >
                            Join Group
                        </Button>
                    </div>
                )}

                {postContent}

                <div className='no-rides'>
                    {/* add space to bottom of page for better scroll experience */}
                </div>
            </Layout>

            {/* Commenting Modal */}
            <CommentModal />

        </Fragment>
    )
}

ReviewPage.propTypes = {
    setPage: PropTypes.func.isRequired,
    add_To_Recent_History: PropTypes.func.isRequired,
    clearEditorText: PropTypes.func.isRequired, 
    clearEditorFiles: PropTypes.func.isRequired, 
    clearUrls: PropTypes.func.isRequired,
    toggleCommentModal: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired,
    getReviewById: PropTypes.func.isRequired,
    getComments_Review: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    ad: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    post: state.post,
    auth: state.auth,
    nav: state.nav,
    ad: state.ad
})

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setPage, 
    add_To_Recent_History,
    clearEditorText, 
    clearEditorFiles, 
    clearUrls,
    toggleCommentModal, 
    toggleAuthModal,
    getReviewById, 
    getComments_Review, 
    editUsername,
    setAlert
})(ReviewPage);
